import { render, staticRenderFns } from "./AiFullText.vue?vue&type=template&id=59b5c969&scoped=true"
import script from "./AiFullText.vue?vue&type=script&lang=js"
export * from "./AiFullText.vue?vue&type=script&lang=js"
import style0 from "./AiFullText.vue?vue&type=style&index=0&id=59b5c969&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59b5c969",
  null
  
)

export default component.exports